import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import { sentryBeforeSend } from './sentry-filters';

const SENTRY_DNS = import.meta.env.VITE_SENTRY_DNS;

Sentry.init({
  dsn: SENTRY_DNS,
  integrations: [
    // React Router v6 integration: route-specific transaction names (e.g. /c/:channel not /c/123)
    // when the app uses Sentry.wrapCreateBrowserRouter(createBrowserRouter).
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],

  // Filter events before sending to Sentry
  beforeSend: sentryBeforeSend,

  // Ignore known benign errors
  ignoreErrors: [
    // Audio player race condition: play() interrupted by pause()
    'AbortError: The play() request was interrupted',
    // Browser-level abort errors for media playback
    /The play\(\) request was interrupted/,
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});
